<div class="progress-chart" #chartRef></div>
